import { URL } from '../common/constants';
import { IWebinar, IWebinarLog } from '../common/model/webinar.model';
import * as services from '.';
import * as webinarUtils from '../utils/webinar.utils';
import { AxiosRequestConfig } from 'axios';
import { default as FormData } from "form-data";

export interface IWebinarsService {
  fetch(id: string): Promise<IWebinar>;
  create(request: IWebinar): Promise<IWebinar>;
  update(request: IWebinar): Promise<IWebinar>;
}

class WebinarsService implements IWebinarsService {
  public constructor(private httpClient: services.IHttpClient) {

  }

  public async fetch(id: string): Promise<IWebinar> {
    return webinarUtils.initDates(await this.httpClient.getCustom<IWebinar>(`${URL.WEB.BASE}${URL.WEB.WEBINARS}/${id}`));
  }

  public async create(webinar: IWebinar): Promise<IWebinar> {
    const options: AxiosRequestConfig = {
      headers: [{
        'content-type': 'multipart/form-data'
      }]
    };

    /*let data = new FormData();
    data.append('Active', webinar.active);
    data.append('Name', webinar.name);

    //data.append('Date', webinar.date);
    var datestr = (new Date(webinar.date.toDate())).toUTCString();
    data.append("Date", datestr);

    data.append('Speakers', webinar.speakers);
    data.append('VideoUrl', '');

    //data.append('Video', fs.createReadStream(webinar.video.name));
    data.append('Video', webinar.video, webinar.video.name);

    data.append('Id', '');
    data.append('Description', webinar.description);*/

    const data = this.getFormData(webinar);

    return webinarUtils.initDates(await this.httpClient.postCustom(`${URL.WEB.BASE}${URL.WEB.WEBINARS}`, data, options));
  }

  public async update(webinar: IWebinar): Promise<IWebinar> {
    const options: AxiosRequestConfig = {
      headers: [{
        'content-type': 'multipart/form-data'
      }]
    };

    const data = this.getFormData(webinar);

    return webinarUtils.initDates(await this.httpClient.putCustom(`${URL.WEB.BASE}${URL.WEB.WEBINARS}/${webinar.id}`, data, options));
  }

  public async createLog(webinarLog: IWebinarLog): Promise<IWebinarLog> {
    return await this.httpClient.postCustom(`${URL.WEB.BASE}${URL.WEB.WEBINARS}/createLog`, webinarLog);
  }

  private getFormData(webinar: IWebinar): FormData {
    const data = new FormData();
    data.append('Active', webinar.active);
    data.append('Name', webinar.name);

    const dateStr = (new Date(webinar.date.toDate())).toUTCString();
    data.append("Date", dateStr);

    data.append('Speakers', webinar.speakers);
    data.append('VideoUrl', webinar.videoUrl);

    if (webinar.video !== undefined && webinar.video != null) {
      data.append('Video', webinar.video, webinar.video.name);
    }    

    data.append('Id', '');
    data.append('Description', webinar.description);

    return data;
  }
}

export const webinarsService = new WebinarsService(services.httpClient);
